import { render } from "./PreviewSessionNoteFieldForm.vue?vue&type=template&id=36722f5b"
import script from "./PreviewSessionNoteFieldForm.vue?vue&type=script&lang=js"
export * from "./PreviewSessionNoteFieldForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__